export default __webpack_public_path__ + "static/Banners_a3-f76734d552be07138a09091836ed3a4d.jpg";